import React, { Component } from 'react'
import classNames from 'classnames'
import ReciteMe from '~/components/ReciteMe'
import Notices from './Notices'
import * as styles from '../../styles/layout/toolbar.module.scss'

export default class Toolbar extends Component {
  render () {
    const _render = () => {
      return (
        <div className={styles.toolbar}>
          <div className={classNames(styles.container, 'grid-container')}>
            <Notices integrated />

            <ReciteMe title="Accessibility Toolbar" />
          </div>
        </div>
      )
    }

    return _render()
  }
}
